import { createStructuredSelector } from 'reselect'

const sessionExpired = ({ sessionExpiry }) => sessionExpiry.getIn(['sessionExpired'], false)

export default createStructuredSelector({
  sessionExpired
})
